import { render, staticRenderFns } from "./commerciali.vue?vue&type=template&id=4d5685a1&"
import script from "./commerciali.vue.ts?vue&type=script&lang=ts&"
export * from "./commerciali.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports